module.exports = __webpack_public_path__ + "img/hair_back_male_long.aa499795.png";